module.exports = __webpack_public_path__ + "eb98da0d562724c5a8052adf9b28ab63.png";